import _createForOfIteratorHelper from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.concat.js";
import { computed, defineComponent, nextTick, ref, watch } from "vue"; // modules

import { PCTypes, RetailOptionType } from "@/types/db/product-category";
import { fetchAllPCsTimeslotsByDate, getTimeslotsByDate } from "@/utils/helpers/timeslots";
import { getProductCategoriesByIds, getProductCategoriesByPriceIds, queryProductCategoriesByTicketGroup } from "@/dexie/product-category";
import Card from "@/components/Card.vue";
import { Virtual, FreeMode, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue"; // Import Swiper styles

import "swiper/swiper.scss"; // core Swiper

import "swiper/modules/navigation/navigation.scss"; // Navigation module

import "swiper/modules/pagination/pagination.scss"; // Pagination module

import { getLanguage } from "@/utils/helpers/lang";
import dayjs from "dayjs";
import POSConfigModule from "@/store/modules/pos-config";
import _cloneDeep from "lodash/cloneDeep";
import { Calendar } from "@element-plus/icons-vue";
import { sortedIndex } from "lodash";
import { getGroupDayJsTimeFormat } from "@/utils/helpers/dates";
import { selectedConfig } from "@/utils/vue-helpers/pos-config"; // import 'dayjs/locale/fr' // import the French locale for dayjs

import { ElConfigProvider } from "element-plus";
import fr from "element-plus/lib/locale/lang/fr";
import de from "element-plus/lib/locale/lang/de";
import en from "element-plus/lib/locale/lang/en";
import it from "element-plus/lib/locale/lang/it";
import AppModule from "@/store/modules/app";
import infoIcon from "@/assets/images/svg/info-circle.svg";
import NotificationService from "@/services/notification.service";
import { useI18n } from "vue-i18n";
import todayIcon from "@/assets/images/svg/calendar-today.svg";
import todayIconBlack from "@/assets/images/svg/calendar-today-black.svg";
import { ModalStatus } from "@/constants/modal";
import ModalModule from "@/store/modules/modal";
import { recordOperationDuration } from "@/utils/vue-helpers/common";
import { es } from "element-plus/es/locale";
import CommonModule from "@/store/modules/common";
import { LogService } from "@/services/logging"; // Cache for calendar dates

var ticketGroupDates = {}; // Should have added swiper as ref in the component but couldn't access it in methods after doing that.

var swiper = null;
export default defineComponent({
  name: "CalendarCards",
  components: {
    Card: Card,
    Swiper: Swiper,
    SwiperSlide: SwiperSlide,
    ElConfigProvider: ElConfigProvider
  },
  props: {
    ticketGroupId: {
      type: Number,
      required: true
    }
  },
  setup: function setup() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var loading, selectedDate, allDates, pulledDates, datepicker, isFetchingFutureDate, todayDate, calendarCardsContainer, locale, _useI18n, t, setSwiperRef, openCalendar, isDateDisabled, cards, didScroll, handleScroll, handleTouchStart, scrollToGroupingHour, scrollToTimeSlot, _scrollToTimeSlot, scrollToFirstAvailableEvent, _scrollToFirstAvailableEvent;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _scrollToFirstAvailableEvent = function _scrollToFirstAvailab2() {
                _scrollToFirstAvailableEvent = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(product) {
                  var targetDate, targetEventTime, _targetEventTime, firstGroupingHour;

                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          if (calendarCardsContainer.value) {
                            _context2.next = 2;
                            break;
                          }

                          return _context2.abrupt("return");

                        case 2:
                          _context2.next = 4;
                          return nextTick();

                        case 4:
                          if (!product) {
                            _context2.next = 16;
                            break;
                          }

                          // find an event group with still ongoing or upcoming events for a specific ticket
                          targetDate = selectedDate.value; // set target date time to current time to avoid scrolling to already ended time slots

                          if (this.areEqualDates(targetDate, dayjs().toDate())) {
                            targetDate = dayjs().toDate();
                          }

                          targetEventTime = Object.keys(cards.value).find(function (eventTime) {
                            var eventGroup = cards.value[eventTime];
                            var eventEndingAfterCurrentTime = eventGroup.find(function (event) {
                              var eventEnd = dayjs(event.endDateTime);
                              return event.productCategoryId === product.id && eventEnd.isAfter(dayjs(targetDate));
                            });

                            if (eventEndingAfterCurrentTime) {
                              return true;
                            }

                            return false;
                          });

                          if (!targetEventTime) {
                            _context2.next = 13;
                            break;
                          }

                          scrollToGroupingHour(targetEventTime);
                          return _context2.abrupt("return", true);

                        case 13:
                          return _context2.abrupt("return", false);

                        case 14:
                          _context2.next = 17;
                          break;

                        case 16:
                          if (dayjs(selectedDate.value).isSame(dayjs(), "day")) {
                            // find an event group with still ongoing or upcoming events today only
                            _targetEventTime = Object.keys(cards.value).find(function (eventTime) {
                              var eventGroup = cards.value[eventTime];
                              var eventEndingAfterCurrentTime = eventGroup.find(function (event) {
                                var eventEnd = dayjs(event.endDateTime);
                                return eventEnd.isAfter(dayjs());
                              });

                              if (eventEndingAfterCurrentTime) {
                                return true;
                              }

                              return false;
                            });

                            if (_targetEventTime) {
                              scrollToGroupingHour(_targetEventTime);
                            }
                          } else {
                            // go back to the first ticket group if its a future date
                            firstGroupingHour = calendarCardsContainer.value.querySelector("div > p.grouping-hour");

                            if (firstGroupingHour) {
                              firstGroupingHour.scrollIntoView({
                                block: "start",
                                behavior: "auto"
                              });
                            }
                          }

                        case 17:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, this);
                }));
                return _scrollToFirstAvailableEvent.apply(this, arguments);
              };

              scrollToFirstAvailableEvent = function _scrollToFirstAvailab(_x2) {
                return _scrollToFirstAvailableEvent.apply(this, arguments);
              };

              _scrollToTimeSlot = function _scrollToTimeSlot3() {
                _scrollToTimeSlot = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(timeslot) {
                  var targetEventTime;
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (calendarCardsContainer.value) {
                            _context.next = 2;
                            break;
                          }

                          return _context.abrupt("return");

                        case 2:
                          _context.next = 4;
                          return nextTick();

                        case 4:
                          targetEventTime = Object.keys(cards.value).find(function (eventTime) {
                            var eventGroup = cards.value[eventTime];
                            var correspondingEvent = eventGroup.find(function (event) {
                              var eventStart = dayjs(event.startDateTime);
                              return eventStart.isSame(dayjs(timeslot));
                            });

                            if (correspondingEvent) {
                              return true;
                            }

                            return false;
                          });

                          if (targetEventTime) {
                            scrollToGroupingHour(targetEventTime);
                          }

                        case 6:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));
                return _scrollToTimeSlot.apply(this, arguments);
              };

              scrollToTimeSlot = function _scrollToTimeSlot2(_x) {
                return _scrollToTimeSlot.apply(this, arguments);
              };

              scrollToGroupingHour = function _scrollToGroupingHour(time) {
                if (!calendarCardsContainer.value) {
                  return;
                }

                var groupingHour = calendarCardsContainer.value.querySelectorAll("div > p.grouping-hour"); // find element to scroll to

                for (var i = 0; i < groupingHour.length; i++) {
                  var element = groupingHour[i];

                  if (element.innerText === time) {
                    element.scrollIntoView({
                      block: "start",
                      behavior: "smooth"
                    });
                    break;
                  }
                }
              };

              handleTouchStart = function _handleTouchStart(e) {
                didScroll.value = false;
              };

              handleScroll = function _handleScroll(e) {
                didScroll.value = true;
              };

              isDateDisabled = function _isDateDisabled(date) {
                // disable if no dates are available
                var dates = allDates.value;

                if (!dates || !dates.length) {
                  return true;
                }

                var dateJS = dayjs(date); // Disable before today

                if (dateJS.isBefore(dayjs(), "day")) {
                  return true;
                }

                return false;
              };

              openCalendar = function _openCalendar() {
                datepicker.value.focus();
              };

              setSwiperRef = function _setSwiperRef(swp) {
                swiper = swp;
              };

              loading = ref(true); // when first loading we select today

              selectedDate = ref(new Date());
              allDates = ref(null);
              pulledDates = ref(null);
              datepicker = ref("datepicker");
              isFetchingFutureDate = ref(false);
              todayDate = ref(new Date());
              calendarCardsContainer = ref();
              locale = computed(function () {
                var languages = {
                  fr: fr,
                  de: de,
                  en: en,
                  it: it,
                  es: es
                };
                var currentLanguage = AppModule.language;
                var loc = languages[currentLanguage];
                return loc;
              });
              _useI18n = useI18n({}), t = _useI18n.t; // Sets Swiper

              loading.value = false; // initiating cards variable with today's timeslots data, and make it reactive
              // let cards = ref(await selectDay(new Date()));

              cards = ref({});
              didScroll = ref(false);
              return _context3.abrupt("return", {
                dayjs: dayjs,
                selectedDate: selectedDate,
                isFetchingFutureDate: isFetchingFutureDate,
                // getCards,
                cards: cards,
                loading: loading,
                datepicker: datepicker,
                openCalendar: openCalendar,
                isDateDisabled: isDateDisabled,
                setSwiperRef: setSwiperRef,
                Calendar: Calendar,
                allDates: allDates,
                pulledDates: pulledDates,
                modules: [Navigation, Virtual, FreeMode],
                locale: locale,
                handleScroll: handleScroll,
                handleTouchStart: handleTouchStart,
                didScroll: didScroll,
                infoIcon: infoIcon,
                t: t,
                todayIcon: todayIcon,
                todayIconBlack: todayIconBlack,
                todayDate: todayDate,
                calendarCardsContainer: calendarCardsContainer,
                scrollToFirstAvailableEvent: scrollToFirstAvailableEvent,
                scrollToTimeSlot: scrollToTimeSlot
              });

            case 24:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
      var operationStartTime, operationEndTime, operationDuration;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              operationStartTime = performance.now();
              ticketGroupDates = {};
              _context7.next = 4;
              return _this.loadDates();

            case 4:
              _context7.next = 6;
              return _this.selectFirstDate();

            case 6:
              // meausre performance
              operationEndTime = performance.now();
              operationDuration = operationEndTime - operationStartTime;
              recordOperationDuration("CalendarCards (".concat(_this.ticketGroupId, ")"), operationDuration);

              _this.emitter.emit("calendarCardsMounted"); // Make sure that whenever the ticketGroupId is changed, we re-render the view.
              // This makes sure that we are able to switch between CalendarGrids, otherwise,
              // the old calendar grid will remain available.
              // Reference  L3-3059


              watch(function () {
                return _this.ticketGroupId;
              }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var _operationStartTime, _operationEndTime, _operationDuration;

                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!_this.ticketGroupId) {
                          _context4.next = 9;
                          break;
                        }

                        _operationStartTime = performance.now(); // When user moves to another ticketGroup, he shouldn't see the selected day of the previous ticketGroup in the datePicker
                        // Lets reload dates

                        _context4.next = 4;
                        return _this.loadDates();

                      case 4:
                        _context4.next = 6;
                        return _this.selectFirstDate();

                      case 6:
                        // meausre performance
                        _operationEndTime = performance.now();
                        _operationDuration = _operationEndTime - _operationStartTime;
                        recordOperationDuration("CalendarCards (".concat(_this.ticketGroupId, ")"), _operationDuration);

                      case 9:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4);
              }))); // Wheneever the POS config is changed or selected again, we reset the cache cause we load only 1 day for now.

              watch(selectedConfig, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        if (!selectedConfig.value) {
                          _context5.next = 6;
                          break;
                        }

                        ticketGroupDates = {};
                        _context5.next = 4;
                        return _this.loadDates();

                      case 4:
                        _context5.next = 6;
                        return _this.selectFirstDate();

                      case 6:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5);
              }))); // listen for emitted event by the products table (Products.vue)

              _this.emitter.on("scrollToRecurringTicket", /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(data) {
                  var dayAlreadyLoaded;
                  return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          // close the modal that emitted this event
                          ModalModule.setStatus(ModalStatus.Hidden);
                          dayAlreadyLoaded = _this.allDates.find(function (d) {
                            return _this.areEqualDates(d, data.date);
                          });

                          if (!dayAlreadyLoaded) {
                            _context6.next = 7;
                            break;
                          }

                          _context6.next = 5;
                          return _this.getCards(data.date);

                        case 5:
                          _context6.next = 9;
                          break;

                        case 7:
                          _context6.next = 9;
                          return _this.selectCustomDate(data.date);

                        case 9:
                          _context6.next = 11;
                          return _this.scrollToFirstAvailableEvent(data.product);

                        case 11:
                          if (!_context6.sent) {
                            _context6.next = 15;
                            break;
                          }

                          NotificationService.showCustomInfoWithTitle(_this.t("select.ticket"), "Info");
                          _context6.next = 16;
                          break;

                        case 15:
                          NotificationService.showCustomMessage(_this.t("calendar.no-timeslots"), "warning");

                        case 16:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _callee6);
                }));

                return function (_x3) {
                  return _ref3.apply(this, arguments);
                };
              }());

            case 13:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  },
  beforeUnmount: function beforeUnmount() {
    swiper = null; // turn off emitter listener to avoid multiple firings

    this.emitter.off("scrollToRecurringTicket");
  },
  methods: {
    loadDates: function loadDates() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var startTime, today, dates, datesCached, d, availableDates;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                startTime = performance.now(); // Get all dates that have availabilities
                // Make sure "Today" button always reflects the current day (handles the app staying open overnight)

                today = dayjs().startOf("day");
                _this2.todayDate = today.toDate();
                CommonModule.purgePastTicketGroupDates(_this2.todayDate); // Make sure that Cache has an entry for current Ticket group

                if (!ticketGroupDates[_this2.ticketGroupId]) {
                  ticketGroupDates[_this2.ticketGroupId] = [];
                }

                dates = ticketGroupDates[_this2.ticketGroupId];
                datesCached = !!dates.length; // make sure that at least today is loaded

                if (!CommonModule.ticketGroupLoadedDates[_this2.ticketGroupId]) {
                  d = new Date(); // UTC set to midnight

                  CommonModule.addTicketGroupLoadedDates({
                    ticketGroupId: _this2.ticketGroupId,
                    date: new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()))
                  });
                }

                if (!datesCached) {
                  // Compute dates in case cache doesn't already have cached dates
                  dates = CommonModule.ticketGroupLoadedDates[_this2.ticketGroupId] || [];
                  ticketGroupDates[_this2.ticketGroupId] = dates;
                } // Filter out dates that are before today (past dates are no longer relevant)


                availableDates = _toConsumableArray(dates).filter(function (d) {
                  return !dayjs(d).isBefore(today, "day");
                }); // if dates are cached, upper calendar doesn't get displayed, so let's add a small
                // delay for that

                if (!datesCached) {
                  _context8.next = 13;
                  break;
                }

                _context8.next = 13;
                return nextTick();

              case 13:
                // TODO @Riyadh: Check logic
                _this2.allDates = availableDates;
                _this2.pulledDates = _toConsumableArray(availableDates);
                recordOperationDuration("CalendarCards.loadDates (".concat(_this2.ticketGroupId, ")"), performance.now() - startTime);

              case 16:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },

    /**
     * Returns an object of grouped cards by hour
     * @param a date
     */
    selectDay: function selectDay(day) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var selectDayStart, date, cards, getTimeslotsStart, dayTimeSlots, groupTimeslotsStart, groupedTimeslots, batchFetchStart, allTimeslots, uniqueCategoryIds, products, productMap, buildCardsStart, _loop, key;

        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                selectDayStart = performance.now(); // Lets use a copy of the parameter Date object to avoid changing the original value
                // let date = new Date(day.getTime());

                date = dayjs(day).toDate();
                cards = {}; // One rule for dates:
                // 2022-04-21T00:00:00.000Z is actually the last moment of the day, not the first moment
                // Why? If you add one second to it you will get 2022-04-22T00:00:01.000Z
                // 1- Calendar view: give me all the timeslots of day x from database.
                // (startDateTime >= midNight(day x) && startDateTime < TomorrowMidnight(day x) )
                // Add now time of the user to the date object so that we only show slots related to now (check getTimeslotsByDate() for more)
                // TODO Riyadh: Check
                // N.B: for FlipLab we show all slots of today even the ended ones

                date = new Date(date.toDateString() + " " + new Date().toTimeString()); // Step 1: Get timeslots by date

                getTimeslotsStart = performance.now();
                _context9.next = 7;
                return getTimeslotsByDate(date, _this3.ticketGroupId);

              case 7:
                dayTimeSlots = _context9.sent;
                recordOperationDuration("CalendarCards.selectDay.getTimeslotsByDate (".concat(_this3.ticketGroupId, ")"), performance.now() - getTimeslotsStart); // Step 2: group timeslots by hour

                groupTimeslotsStart = performance.now();
                groupedTimeslots = _this3.groupTimeslotsByHour(dayTimeSlots) || {};
                recordOperationDuration("CalendarCards.selectDay.groupTimeslotsByHour (".concat(_this3.ticketGroupId, ")"), performance.now() - groupTimeslotsStart); // Step 3: batch-fetch all product categories in a single query

                batchFetchStart = performance.now();
                allTimeslots = Object.values(groupedTimeslots).flat();
                uniqueCategoryIds = _toConsumableArray(new Set(allTimeslots.map(function (ts) {
                  return ts.categoryId;
                })));
                _context9.next = 17;
                return getProductCategoriesByIds(uniqueCategoryIds);

              case 17:
                products = _context9.sent;
                productMap = new Map(products.map(function (p) {
                  return [p.id, p];
                }));
                recordOperationDuration("CalendarCards.selectDay.batchFetchProducts (".concat(_this3.ticketGroupId, ")"), performance.now() - batchFetchStart); // Step 4: convert each ITimeSlots into ICardData

                buildCardsStart = performance.now();

                _loop = function _loop(key) {
                  for (var i = 0; i < groupedTimeslots[key].length; i++) {
                    var tempCards = _this3.getCardData(groupedTimeslots[key][i], productMap);

                    if (!cards[key]) {
                      cards[key] = tempCards.flat();
                    } else {
                      tempCards.flat().forEach(function (element) {
                        cards[key].push(element);
                      });
                    }
                  } // Done filling in cards[key]
                  // Lets now sort the cards in cards[key] by their category name


                  if (cards[key]) {
                    cards[key].sort(function (a, b) {
                      if (Number(a.sortOrderPos) > Number(b.sortOrderPos)) {
                        return 1;
                      } else if (Number(a.sortOrderPos) < Number(b.sortOrderPos)) {
                        return -1;
                      } // a must be equal to b


                      return 0;
                    });
                  }
                };

                for (key in groupedTimeslots) {
                  _loop(key);
                }

                recordOperationDuration("CalendarCards.selectDay.buildCards (".concat(_this3.ticketGroupId, ")"), performance.now() - buildCardsStart);
                recordOperationDuration("CalendarCards.selectDay (".concat(_this3.ticketGroupId, ")"), performance.now() - selectDayStart);
                return _context9.abrupt("return", cards);

              case 26:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },

    /**
     * Takes an array of timeslots and returns an object of timeslots grouped by time intervals.
     * The interval between groups follows POSConfigModule.selectedGrid?.timeGrid (in minutes),
     * defaulting to 60 minutes if not configured.
     */
    groupTimeslotsByHour: function groupTimeslotsByHour(timeslots) {
      var _POSConfigModule$sele;

      if (!(timeslots !== null && timeslots !== void 0 && timeslots.length)) {
        return;
      } // Sort timeslots by startDateTime (ISO strings are lexicographically sortable)


      timeslots.sort(function (a, b) {
        return a.startDateTime < b.startDateTime ? -1 : a.startDateTime > b.startDateTime ? 1 : 0;
      });
      var timeGrid = ((_POSConfigModule$sele = POSConfigModule.selectedGrid) === null || _POSConfigModule$sele === void 0 ? void 0 : _POSConfigModule$sele.timeGrid) || 60;
      var timeFormat = getGroupDayJsTimeFormat(); // Generate bucket start times: from the first timeslot's hour-floor
      // to the last timeslot's end, stepping by timeGrid minutes

      var firstBucket = dayjs(timeslots[0].startDateTime).startOf("hour");
      var lastEnd = dayjs(timeslots[timeslots.length - 1].endDateTime);
      var buckets = [];
      var cursor = firstBucket;

      while (cursor.isBefore(lastEnd)) {
        buckets.push(cursor);
        cursor = cursor.add(timeGrid, "minute");
      } // Assign each timeslot to the appropriate bucket in a single pass


      var result = {};

      var _iterator = _createForOfIteratorHelper(timeslots),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var slot = _step.value;
          var slotStart = dayjs(slot.startDateTime); // Find the last bucket whose start is <= slotStart (reverse scan)

          var bucketIdx = 0;

          for (var i = buckets.length - 1; i >= 0; i--) {
            if (!slotStart.isBefore(buckets[i])) {
              bucketIdx = i;
              break;
            }
          }

          var key = buckets[bucketIdx].format(timeFormat);

          if (!result[key]) {
            result[key] = [];
          }

          result[key].push(slot);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return result;
    },
    getCards: function getCards(day) {
      var _arguments = arguments,
          _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var options, getCardsStart, _options$refresh, refresh, pullStart;

        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                options = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {};
                getCardsStart = performance.now();
                _options$refresh = options.refresh, refresh = _options$refresh === void 0 ? false : _options$refresh;

                if (!refresh) {
                  _context10.next = 18;
                  break;
                }

                _context10.prev = 4;
                AppModule.setIsBackgroundLoading(true);
                pullStart = performance.now();
                _context10.next = 9;
                return _this4.pullAndStoreTimeslotsByDate(day.toISOString(), _this4.ticketGroupId);

              case 9:
                recordOperationDuration("CalendarCards.getCards.pullTimeslots (".concat(_this4.ticketGroupId, ")"), performance.now() - pullStart);
                _context10.next = 15;
                break;

              case 12:
                _context10.prev = 12;
                _context10.t0 = _context10["catch"](4);
                LogService.info("Availability: Error pulling timeslots for date", {
                  error: _context10.t0,
                  ticketGroupId: _this4.ticketGroupId,
                  date: day.toISOString()
                });

              case 15:
                _context10.prev = 15;
                AppModule.setIsBackgroundLoading(false);
                return _context10.finish(15);

              case 18:
                _context10.next = 20;
                return _this4.selectDay(day);

              case 20:
                _this4.cards = _context10.sent;
                _this4.selectedDate = new Date(day.getTime());

                if (POSConfigModule.isFlipLab) {
                  _this4.scrollToFirstAvailableEvent();
                }

                recordOperationDuration("CalendarCards.getCards (".concat(_this4.ticketGroupId, ")"), performance.now() - getCardsStart);

              case 24:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, null, [[4, 12, 15, 18]]);
      }))();
    },

    /**
     * Takes an object of type ITimeSlot and a pre-fetched product map,
     * returns an object of type ICardData.
     * Synchronous, no DB calls, products are looked up from the map.
     */
    getCardData: function getCardData(timeslot, productMap) {
      var startTime = performance.now();
      var isSeparatedButtons = POSConfigModule.isSeperatedButtons;
      var product = productMap.get(timeslot.categoryId);
      var currentLanguage = getLanguage();

      if (!isSeparatedButtons) {
        // IF it is seating plan product then we take the minPrice of all sub-categories
        // else we take minPricce of prices
        var minPrice = product && product.type === PCTypes[PCTypes.Seated] && product.subCategories && product.subCategories.length ? product.subCategories.map(function (sbpc) {
          return sbpc.prices;
        }).flat().sort(function (p1, p2) {
          return Number(p1) - Number(p2);
        })[0].value : product === null || product === void 0 ? void 0 : product.prices.sort(function (p1, p2) {
          return Number(p1) - Number(p2);
        })[0].value;
        var result = [{
          productCategoryId: product === null || product === void 0 ? void 0 : product.id,
          productName: (product === null || product === void 0 ? void 0 : product.product.nameLocale[currentLanguage]) || (product === null || product === void 0 ? void 0 : product.product.name),
          categoryName: (product === null || product === void 0 ? void 0 : product.nameLocale[currentLanguage]) || (product === null || product === void 0 ? void 0 : product.name),
          dbAvailability: timeslot.availability,
          startDateTime: timeslot.startDateTime,
          endDateTime: timeslot.endDateTime,
          currency: product === null || product === void 0 ? void 0 : product.product.currency,
          pictureUrl: product === null || product === void 0 ? void 0 : product.product.pictureUrl,
          price: minPrice,
          prices: product === null || product === void 0 ? void 0 : product.prices,
          productCategory_ID: product === null || product === void 0 ? void 0 : product._id,
          timeslot_ID: timeslot._id,
          type: String(product === null || product === void 0 ? void 0 : product.type),
          saleStartType: product === null || product === void 0 ? void 0 : product.saleStartType,
          saleStart: product === null || product === void 0 ? void 0 : product.saleStart,
          saleEndType: product === null || product === void 0 ? void 0 : product.saleEndType,
          saleEnd: product === null || product === void 0 ? void 0 : product.saleEnd,
          salesEndDurationMinutes: product === null || product === void 0 ? void 0 : product.salesEndDurationMinutes,
          salesStartDurationDays: product === null || product === void 0 ? void 0 : product.salesStartDurationDays,
          sortOrderPos: Number(product === null || product === void 0 ? void 0 : product.sortOrderPos),
          stockIds: (product === null || product === void 0 ? void 0 : product.stockIds) || [],
          booked: timeslot.booked,
          // Seating Plan logic
          eventKey: product && (product.type === PCTypes[PCTypes.SeatedSub] || product.type === PCTypes[PCTypes.Seated]) && !product.isReccuringSeating ? String(product.resourceEventKey) : timeslot.eventKey,
          isReccuringSeating: product && (product.type === PCTypes[PCTypes.SeatedSub] || product.type === PCTypes[PCTypes.Seated]) ? Number(product.isReccuringSeating) : null,
          seatingParentPSCId: product && product.type === PCTypes[PCTypes.SeatedSub] ? product.seatingParentPSCId : null,
          seatingParentCategoryName: product && product.type === PCTypes[PCTypes.SeatedSub] ? product.seatingParentCategoryName : "",
          seatedSubs: product && product.subCategories ? product.subCategories : []
        }];
        recordOperationDuration("CalendarCards.getCardData (".concat(timeslot.categoryId, ")"), performance.now() - startTime);
        return result;
      } else {
        // We need to show prices separated in copies of the ICardData
        var _result = product ? this.splitPCs(product, timeslot) : [];

        recordOperationDuration("CalendarCards.getCardData (".concat(timeslot.categoryId, ")"), performance.now() - startTime);
        return _result;
      }
    },
    splitPCs: function splitPCs(pc, timeslot) {
      // This function takes a PC object and returns an array of PCs each with only one price. PCs are basically a copy of each other except the price
      var CDs = [];
      var currentLanguage = getLanguage();
      var pricesCount = pc.prices.length;

      for (var j = 0; j < pricesCount; j++) {
        // if this is retail PC and has more than one price and this price has the default price then skip it, because we need prices with not-default-retail
        if (pricesCount > 1 && pc.type === PCTypes[PCTypes.Retail] && pc.prices[j].retail[0].type === RetailOptionType.Default_Retail_Option) {
          continue;
        }

        var clonedPC = _cloneDeep(pc);

        clonedPC.prices = [];
        clonedPC.prices = [pc.prices[j]];
        var cd = {
          productCategoryId: clonedPC.id,
          productName: clonedPC.product.nameLocale[currentLanguage] || clonedPC.product.name,
          categoryName: clonedPC.nameLocale[currentLanguage] || clonedPC.name,
          dbAvailability: timeslot.availability,
          startDateTime: timeslot.startDateTime,
          endDateTime: timeslot.endDateTime,
          currency: clonedPC.product.currency,
          pictureUrl: clonedPC.product.pictureUrl,
          price: clonedPC.prices.sort(function (p1, p2) {
            return Number(p1) - Number(p2);
          })[0].value,
          prices: clonedPC.prices,
          productCategory_ID: clonedPC._id,
          timeslot_ID: timeslot._id,
          type: String(clonedPC.type),
          saleEnd: clonedPC.saleEnd,
          saleEndType: clonedPC.saleEndType,
          saleStart: clonedPC.saleStart,
          saleStartType: clonedPC.saleStartType,
          salesEndDurationMinutes: clonedPC.salesEndDurationMinutes,
          salesStartDurationDays: clonedPC.salesStartDurationDays,
          sortOrderPos: Number(clonedPC.sortOrderPos),
          stockIds: clonedPC.stockIds || [],
          booked: timeslot.booked,
          // Seating Plan logic
          eventKey: clonedPC && clonedPC.type === PCTypes[PCTypes.SeatedSub] && !clonedPC.isParentReccuringSeating ? clonedPC.seatingParentResourceEventKey : timeslot.eventKey,
          isReccuringSeating: clonedPC && clonedPC.type === PCTypes[PCTypes.SeatedSub] ? clonedPC.isParentReccuringSeating : null,
          seatingParentPSCId: clonedPC && clonedPC.type === PCTypes[PCTypes.SeatedSub] ? clonedPC.seatingParentPSCId : null,
          seatingParentCategoryName: clonedPC && clonedPC.type === PCTypes[PCTypes.SeatedSub] ? clonedPC.seatingParentCategoryName : ""
        };
        CDs.push(cd);
      }

      return CDs;
    },
    areEqualDates: function areEqualDates(date1, date2) {
      if (!date1 || !date2) {
        return false;
      }

      return date1.getDate() === date2.getDate() && date1.getMonth() === date2.getMonth() && date1.getFullYear() === date2.getFullYear();
    },
    selectCustomDate: function selectCustomDate(date) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var startTime, index;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                startTime = performance.now();
                _this5.isFetchingFutureDate = true;
                _context11.prev = 2;
                _context11.next = 5;
                return _this5.pullAndStoreTimeslotsByDate(date.toISOString(), _this5.ticketGroupId);

              case 5:
                // Retrieve the swiper index where that date should be inserted
                index = sortedIndex(_this5.allDates, date); // Check if the date already exists in the horizontal calendar

                if (!dayjs(_this5.allDates[index]).isSame(dayjs(date), "day")) {
                  // Add the date in the right position in the array of dates
                  ticketGroupDates[_this5.ticketGroupId].splice(index, 0, date);
                }

                _context11.next = 9;
                return _this5.loadDates();

              case 9:
                _context11.next = 11;
                return _this5.getCards(date);

              case 11:
                _this5.isFetchingFutureDate = false; //await Timeout.set(100);
                // Slide to that date;

                swiper.slideTo(index);
                CommonModule.addTicketGroupLoadedDates({
                  ticketGroupId: _this5.ticketGroupId,
                  date: date
                });
                recordOperationDuration("CalendarCards.selectCustomDate (".concat(_this5.ticketGroupId, ")"), performance.now() - startTime);
                _context11.next = 24;
                break;

              case 17:
                _context11.prev = 17;
                _context11.t0 = _context11["catch"](2);
                _this5.isFetchingFutureDate = false; // if there's an issue fetching the timeslots or the app is offline let's re-select today's day and show a warning message

                _this5.getCards(_this5.allDates[0]);

                NotificationService.showCustomMessage(_this5.t("error.load-timeslots"), "warning");
                recordOperationDuration("CalendarCards.selectCustomDate.error (".concat(_this5.ticketGroupId, ")"), performance.now() - startTime);
                throw _context11.t0;

              case 24:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, null, [[2, 17]]);
      }))();
    },
    getFutureDates: function getFutureDates(dates) {
      var _this6 = this;

      var d = (dates === null || dates === void 0 ? void 0 : dates.filter(function (d) {
        return !_this6.areEqualDates(d, _this6.todayDate);
      })) || [];
      return d;
    },
    selectFirstDate: function selectFirstDate() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var startTime, b, today;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                startTime = performance.now();

                if (!_this7.allDates.length) {
                  _context12.next = 7;
                  break;
                }

                b = _this7.allDates[0];
                _context12.next = 5;
                return _this7.getCards(b, {
                  refresh: false
                });

              case 5:
                _context12.next = 11;
                break;

              case 7:
                today = new Date(dayjs().toDate());

                _this7.allDates.unshift(today);

                _context12.next = 11;
                return _this7.getCards(today, {
                  refresh: false
                });

              case 11:
                recordOperationDuration("CalendarCards.selectFirstDate (".concat(_this7.ticketGroupId, ")"), performance.now() - startTime);

              case 12:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }))();
    },
    pullAndStoreTimeslotsByDate: function pullAndStoreTimeslotsByDate(date) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var startTime, queryPCsStart, productCategories, categoryIdsSet, seatedSubType, allAddonPriceIds, _iterator2, _step2, pc, _iterator4, _step4, price, _iterator5, _step5, addon, addonLookupStart, addonPCs, _iterator3, _step3, addonPC, fetchTimeslotsStart;

        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                startTime = performance.now();

                if (!(!_this8.ticketGroupId || !date)) {
                  _context13.next = 3;
                  break;
                }

                return _context13.abrupt("return");

              case 3:
                _context13.prev = 3;
                // Retrieve all the PCs that belong to this ticket group (Excluding Retail)
                // SeatedSub PCs are included so we can collect their addon price IDs,
                // but they are excluded from the timeslot fetch set (their timeslots come from the parent Seated PC)
                queryPCsStart = performance.now();
                _context13.next = 7;
                return queryProductCategoriesByTicketGroup({
                  ticketGroupId: _this8.ticketGroupId,
                  excludeTypes: [PCTypes[PCTypes.Retail]]
                });

              case 7:
                productCategories = _context13.sent;
                recordOperationDuration("CalendarCards.pullAndStore.queryPCs (".concat(_this8.ticketGroupId, ")"), performance.now() - queryPCsStart);

                if (productCategories.length) {
                  _context13.next = 11;
                  break;
                }

                return _context13.abrupt("return");

              case 11:
                categoryIdsSet = new Set();
                seatedSubType = PCTypes[PCTypes.SeatedSub]; // Collect all PC IDs and all addon price IDs in a single pass

                allAddonPriceIds = [];
                _iterator2 = _createForOfIteratorHelper(productCategories);

                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    pc = _step2.value;

                    // SeatedSub timeslots are fetched via their parent Seated PC, so we exclude them
                    if (pc.type !== seatedSubType) {
                      categoryIdsSet.add(pc.id);
                    } // Collect addon price IDs from ALL PCs including SeatedSub


                    _iterator4 = _createForOfIteratorHelper(pc.prices);

                    try {
                      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                        price = _step4.value;
                        _iterator5 = _createForOfIteratorHelper(price.addons);

                        try {
                          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                            addon = _step5.value;
                            allAddonPriceIds.push(addon.priceId);
                          }
                        } catch (err) {
                          _iterator5.e(err);
                        } finally {
                          _iterator5.f();
                        }
                      }
                    } catch (err) {
                      _iterator4.e(err);
                    } finally {
                      _iterator4.f();
                    }
                  } // Batch-lookup addon PCs by price IDs (single indexed Dexie query)

                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }

                if (!allAddonPriceIds.length) {
                  _context13.next = 24;
                  break;
                }

                addonLookupStart = performance.now();
                _context13.next = 20;
                return getProductCategoriesByPriceIds(allAddonPriceIds);

              case 20:
                addonPCs = _context13.sent;
                _iterator3 = _createForOfIteratorHelper(addonPCs);

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    addonPC = _step3.value;
                    categoryIdsSet.add(addonPC.id);
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }

                recordOperationDuration("CalendarCards.pullAndStore.addonLookup (".concat(_this8.ticketGroupId, ")"), performance.now() - addonLookupStart);

              case 24:
                // Fetch timeslots of that date
                fetchTimeslotsStart = performance.now();
                _context13.next = 27;
                return fetchAllPCsTimeslotsByDate(_toConsumableArray(categoryIdsSet), date);

              case 27:
                recordOperationDuration("CalendarCards.pullAndStore.fetchTimeslots (".concat(_this8.ticketGroupId, ")"), performance.now() - fetchTimeslotsStart);
                _context13.next = 33;
                break;

              case 30:
                _context13.prev = 30;
                _context13.t0 = _context13["catch"](3);
                LogService.info("Availability: Error pulling timeslots for date ".concat(date, " and ticket group ").concat(_this8.ticketGroupId), {
                  params: {
                    date: date,
                    ticketGroupId: _this8.ticketGroupId
                  },
                  error: _context13.t0
                });

              case 33:
                recordOperationDuration("CalendarCards.pullAndStoreTimeslotsByDate (".concat(_this8.ticketGroupId, ")"), performance.now() - startTime);

              case 34:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, null, [[3, 30]]);
      }))();
    }
  }
});